import * as React from 'react';
import { GikIconDefaultSize, GikIconProps } from '.';

export const Play = React.forwardRef(
  ({ size = GikIconDefaultSize, ...props }: GikIconProps, svgRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        width={size}
        height={size}
        ref={svgRef}
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.0001 59.4C40.0018 59.4 46.7168 56.6186 51.6677 51.6676C56.6187 46.7166 59.4001 40.0017 59.4001 33C59.4001 25.9983 56.6187 19.2833 51.6677 14.3324C46.7168 9.3814 40.0018 6.59998 33.0001 6.59998C25.9984 6.59998 19.2834 9.3814 14.3325 14.3324C9.38152 19.2833 6.6001 25.9983 6.6001 33C6.6001 40.0017 9.38152 46.7166 14.3325 51.6676C19.2834 56.6186 25.9984 59.4 33.0001 59.4ZM31.5316 23.6544C31.0346 23.3228 30.4569 23.1324 29.8602 23.1034C29.2635 23.0744 28.67 23.2079 28.1433 23.4898C27.6165 23.7716 27.1761 24.1912 26.8691 24.7037C26.5621 25.2163 26.4 25.8025 26.4001 26.4V39.6C26.4 40.1974 26.5621 40.7837 26.8691 41.2962C27.1761 41.8087 27.6165 42.2283 28.1433 42.5102C28.67 42.792 29.2635 42.9256 29.8602 42.8966C30.4569 42.8676 31.0346 42.6772 31.5316 42.3456L41.4316 35.7456C41.8836 35.4442 42.2541 35.0359 42.5104 34.557C42.7667 34.078 42.9008 33.5432 42.9008 33C42.9008 32.4568 42.7667 31.9219 42.5104 31.443C42.2541 30.964 41.8836 30.5557 41.4316 30.2544L31.5316 23.6544Z"
            fill="currentColor"
          />
        </g>
      </svg>
    );
  }
);
